export default __webpack_public_path__ + "ef6148d80c88eef397f23f95d10c3af7.jpg";